import { Price } from "./types";

type IntervalPrice = Pick<
  Price,
  "recurring_interval" | "recurring_interval_count"
>;
export function priceIntervalText(price: IntervalPrice, prefix?: string) {
  const { recurring_interval, recurring_interval_count } = price;

  let label = prefix ? `${prefix} cada ` : "cada ";

  const intervalString = parseInterval(recurring_interval);

  if (!intervalString) return "";

  if (recurring_interval_count > 1) {
    label += `${recurring_interval_count} ${intervalString}`;
    if (recurring_interval == "month") {
      label += "es";
    } else {
      label += "s";
    }
  } else {
    label += intervalString;
  }

  return label;
}

export function parseInterval(interval: Price["recurring_interval"]) {
  switch (interval) {
    case "day":
      return "día";
    case "week":
      return "semana";
    case "month":
      return "mes";
    case "year":
      return "año";
    default:
      return "";
  }
}

export function getWorstPrice(prices: Price[]) {
  return prices.slice().sort((a, b) => b.amount - a.amount)[0];
}

export function getSavingsPercent(worstPrice: Price, currentPrice: Price) {
  const worstYearlyAmt = toYearlyAmmount(worstPrice);
  const currYearlyAmt = toYearlyAmmount(currentPrice);

  // returns % saved without % sign
  return Math.trunc(((worstYearlyAmt - currYearlyAmt) / worstYearlyAmt) * 100);
}

function toYearlyAmmount(price: Price) {
  // get yearly equivalent of price
  switch (price.recurring_interval) {
    case "month":
      return (price.amount / price.recurring_interval_count) * 12;
    case "year":
      return price.amount / price.recurring_interval_count;
    case "week":
      return (price.amount / price.recurring_interval_count) * 52.1429; // weeks in a year
    case "day":
      return (price.amount / price.recurring_interval_count) * 365; // weeks in a year
    default:
      return 0;
  }
}
